import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import { Col } from '../../../../../../1stlog-ui/src/components/Bootstrap'
import Select from '../../../../../../1stlog-ui/src/components/Select'
import Field, { useField } from '../../../../../../1stlog-ui/src/components/Field'
import useOrderEntry from '../../../useOrderEntry'
import basicProvider from './basicProvider'

const Wrapper = styled.div``

const ProviderSelect = (props) => {
  const { onlyAllowBasic } = props
  const { providers: externalProviders, currentCustomer, isInternal } = useOrderEntry()

  const providers = useMemo(() => {
    if (!isInternal) {
      return externalProviders
    }
    if (onlyAllowBasic) {
      return [basicProvider]
    }
    return lodash.concat([basicProvider], externalProviders)
  }, [externalProviders, onlyAllowBasic])

  const options = useMemo(() => {
    return lodash.map(providers, (p) => ({ label: p.name, value: p.id }))
  }, [providers])

  const [provider, setProvider] = useField('provider', { asState: true })

  useEffect(() => {
    const desiredProvider = provider || (currentCustomer ? 'standard' : 'basic')
    const targetProvider =
      lodash.find(providers, (p) => p.id === desiredProvider) || lodash.first(providers)
    setTimeout(() => setProvider(lodash.get(targetProvider, 'id')), 0)
  }, [provider, providers])

  if (lodash.size(providers) <= 1) {
    return null
  }

  return (
    <Col md={4}>
      <Wrapper>
        <Field name="provider" label="Dienstleister">
          <Select options={options} direct />
        </Field>
      </Wrapper>
    </Col>
  )
}

export default ProviderSelect
